import { useMemo } from 'react';

import { collection, orderBy, Query, query } from 'firebase/firestore';

import { useCollectionData } from 'react-firebase-hooks/firestore';

import { useAuth } from '../contextProviders/AuthProvider';
import { firestore } from '../firebase';

import type { UsgaPostLog } from '../types/UsgaPost';

/** God only: every attempt to post one score to the USGA, newest first. */
export default function useEventScoreUsgaPostLog(orgId: string | undefined, eventId: string | undefined, scoreId: string | undefined) {
  const { isGod } = useAuth();
  const logQuery = useMemo(() => {
    if (!isGod || !orgId || !eventId || !scoreId) return null;
    return query(
      collection(firestore, `org/${orgId}/event/${eventId}/score/${scoreId}/usgaPostLog`),
      orderBy('createdAt', 'desc'),
    ) as Query<UsgaPostLog>;
  }, [isGod, orgId, eventId, scoreId]);
  const [entries, isLoading, error] = useCollectionData<UsgaPostLog>(logQuery);
  return { entries: entries ?? [], isLoading, error };
}
